import type { HiddenCriterionRef } from '@/entities/dashboards';

/**
 * Ключ критерия в разрезе заключения-владельца — для сравнения наборов скрытых критериев.
 * Одноимённые критерии разных заключений дают разные ключи.
 *
 * Разделитель однозначен, даже если он встречается в имени критерия: идентификатор заключения —
 * число, поэтому первое вхождение разделителя всегда отделяет его от имени.
 */
export const criterionKey = (expertReportId: number, name: string): string => `${expertReportId}|${name}`;

/** Скрыт ли критерий заключения из отображения дашборда. */
export const isCriterionHidden = (
  hidden: HiddenCriterionRef[],
  expertReportId: number,
  name: string,
): boolean => hidden.some((item) => item.expertReportId === expertReportId && item.name === name);

/**
 * Приводит сохранённый набор скрытых критериев к текущему формату.
 *
 * Настройки пользователя приходят с бэкенда как есть, поэтому в них может лежать и прежний
 * формат — голые имена критериев без заключения-владельца. Восстановить по имени заключение
 * нельзя (одно и то же имя встречается в нескольких заключениях), поэтому такая запись
 * отбрасывается: критерий снова виден, и пользователь снимает его заново — уже в своём
 * заключении.
 */
export const normalizeHiddenCriteria = (stored: unknown): HiddenCriterionRef[] => {
  if (!Array.isArray(stored)) return [];
  return stored.filter((item): item is HiddenCriterionRef => {
    if (typeof item !== 'object' || item === null) return false;
    const ref = item as Partial<HiddenCriterionRef>;
    return typeof ref.expertReportId === 'number' && typeof ref.name === 'string';
  });
};
